import { Link as ScrollLink } from 'react-scroll';
import logoViso from '../assets/VISO Analytics 1.png';

const Footer = () => {
  const year = new Date().getFullYear();

  return (
    <footer className="border-t border-gray-200 bg-white">
      <div className="max-w-7xl mx-auto px-6 py-10">
        <div className="grid gap-10 md:grid-cols-2">
          {/* Brand + CTA */}
          <div className="space-y-5">
            <div className="flex items-center gap-3">
              <img src={logoViso} alt="Viso Analytics" className="h-20 w-auto" />
            </div>
            <p className="text-gray-600 text-sm leading-relaxed max-w-md">
              Empowering teams with expert training and practical analytics solutions to accelerate outcomes.
            </p>
            <div className="flex flex-col sm:flex-row gap-3">
              <a
                href="mailto:visoanalytics@gmail.com"
                className="inline-flex items-center justify-center gap-2 rounded-lg bg-blue-600 px-4 py-2.5 text-white shadow-sm hover:bg-blue-700 transition-colors text-sm"
              >
                <svg className="h-4 w-4" fill="none" stroke="currentColor" viewBox="0 0 24 24"><path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M3 8l7.89 5.26a2 2 0 002.22 0L21 8M5 19h14a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2 2v10a2 2 0 012 2z"/></svg>
                Email us
              </a>
              <a
                href="tel:+919922940550"
                className="inline-flex items-center justify-center gap-2 rounded-lg border border-blue-200 bg-white px-4 py-2.5 text-blue-700 hover:border-blue-300 hover:bg-blue-50/40 transition-colors text-sm"
              >
                <svg className="h-4 w-4" fill="none" stroke="currentColor" viewBox="0 0 24 24"><path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M3 5a2 2 0 012-2h3.28a1 1 0 01.948.684l1.498 4.493a1 1 0 01-.502 1.21l-2.257 1.13a11.042 11.042 0 005.516 5.516l1.13-2.257a1 1 0 011.21-.502l4.493 1.498a1 1 0 01.684.949V19a2 2 0 01-2 2h-1C9.716 21 3 14.284 3 6V5z"/></svg>
                Call us
              </a>
            </div>
          </div>

          {/* Navigation */}
          <nav aria-label="Footer" className="grid grid-cols-2 gap-8 sm:max-w-md md:justify-self-end">
            <div>
              <h3 className="text-xs font-semibold uppercase tracking-wider text-gray-900">Company</h3>
              <ul className="mt-4 space-y-3">
                <li>
                  <ScrollLink to="about" smooth duration={500} className="text-gray-600 hover:text-blue-700 cursor-pointer text-sm">
                    About
                  </ScrollLink>
                </li>
                <li>
                  <ScrollLink to="services" smooth duration={500} className="text-gray-600 hover:text-blue-700 cursor-pointer text-sm">
                    Services
                  </ScrollLink>
                </li>
                <li>
                  <ScrollLink to="contact" smooth duration={500} className="text-gray-600 hover:text-blue-700 cursor-pointer text-sm">
                    Contact
                  </ScrollLink>
                </li>
              </ul>
            </div>
            <div>
              <h3 className="text-xs font-semibold uppercase tracking-wider text-gray-900">Resources</h3>
              <ul className="mt-4 space-y-3">
                <li>
                  <button type="button" className="text-gray-600 hover:text-blue-700 text-sm">Privacy Policy</button>
                </li>
                <li>
                  <button type="button" className="text-gray-600 hover:text-blue-700 text-sm">Terms of Service</button>
                </li>
                <li>
                  <a href="https://www.linkedin.com/" target="_blank" rel="noreferrer" className="text-gray-600 hover:text-blue-700 text-sm">
                    LinkedIn
                  </a>
                </li>
              </ul>
            </div>
          </nav>
        </div>

        {/* Bottom bar */}
        <div className="mt-10 border-t border-gray-200 pt-6 flex flex-col sm:flex-row items-center justify-between gap-4">
          <p className="text-gray-500 text-sm">© {year} Viso Analytics. All rights reserved.</p>
          <div className="flex items-center gap-6 text-sm">
            <button type="button" className="text-gray-600 hover:text-blue-700">Privacy</button>
            <button type="button" className="text-gray-600 hover:text-blue-700">Terms</button>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;